'use strict';

const { Component, h } = require('phy');
const InfoSvg = require('@design-system/svg-icons/preact/Info').default;

const getLabel = ({ optionsMsrpHash, option }) => {
  const obj = optionsMsrpHash[option];
  return obj ? obj.label : '';
};

const getInlineStyle = label => (!label ? { display: 'none' } : {});

class MSRPLabel extends Component {
  shouldComponentUpdate() {
    return false;
  }

  componentDidMount() {
    if (window.GIG && window.GIG.Tooltip) {
      window.GIG.Tooltip.init(document.querySelector('.msrp-tooltip-trigger'));
    }
  }

  render() {
    const label = getLabel(this.props);
    const style = getInlineStyle(label);
    const { isRefreshLeftAlign } = this.props;

    /**
     * When under isRefreshLeftAlign experiment, then tooltip will show on hover of the info icon instead
     */
    if (isRefreshLeftAlign) {
      return h(
        '.msrp-container',
        h(
          'span.source-metadata-label',
          {
            style,
          },
          label
        ),
        h(InfoSvg, {
          class: 'tooltip-trigger msrp-tooltip-trigger',
          'data-position': 'top',
          'data-tooltip-id': 'value-source-metadata',
        })
      );
    }
    return h(
      'span.msrp-container.source-metadata-label.tooltip-trigger.msrp-tooltip-trigger',
      {
        'data-position': 'left',
        'data-tooltip-id': 'value-source-metadata',
        style,
      },
      label
    );
  }
}

module.exports = MSRPLabel;
